import { useFeatureFlag } from 'common/hooks/useFeatureFlags';
import { useGetAchievementCategoryStatusesQuery } from 'graphql.types';
import { useEffect, useState } from 'react';

const useAchievementsEnabled = () => {
  const [enabled, setEnabled] = useState(false);

  const ffEnabled = useFeatureFlag('achievements_p0');

  const { data } = useGetAchievementCategoryStatusesQuery();
  const categoriesEnabled = data?.achievementCategories.some(category => category.enabled);

  useEffect(() => {
    const isEnabled = ffEnabled && categoriesEnabled;
    setEnabled(isEnabled || false);
  }, [ffEnabled, categoriesEnabled]);

  return { enabled, categoriesEnabled, ffEnabled };
};

export default useAchievementsEnabled;
